// shared/application/ejecutarEliminaciones.js  (DELETE secuencial de imágenes guardadas marcadas). Sin JSX ni Swal.
// Lo comparten el guardado de formularios (guardarConHijos) y el detalle ("Eliminar N imágenes").
import { mensajeErrorEliminacion, esImagenYaEliminada } from '../domain/media';

/**
 * Elimina `uuids` una a una con `media.remove(uuid)`, sin detenerse ante un fallo. 404 = ya no existe = éxito.
 * `onEstado(uuid, 'deleting' | 'done' | 'error', mensaje)` informa el progreso por imagen.
 * Devuelve { eliminadas: [uuid], fallidas: [{ uuid, error }] } con `error` = mensaje en español (solo el backend si es controlado).
 */
export const ejecutarEliminaciones = async ({ uuids = [], media, onEstado }) => {
  const resultado = { eliminadas: [], fallidas: [] };
  for (let i = 0; i < uuids.length; i++) {
    const uuid = uuids[i];
    if (onEstado) onEstado(uuid, 'deleting');
    try {
      await media.remove(uuid);
      resultado.eliminadas.push(uuid);
      if (onEstado) onEstado(uuid, 'done');
    } catch (e) {
      if (esImagenYaEliminada(e)) {
        resultado.eliminadas.push(uuid);
        if (onEstado) onEstado(uuid, 'done');
        continue;
      }
      const mensaje = mensajeErrorEliminacion(e);
      resultado.fallidas.push({ uuid, error: mensaje });
      if (onEstado) onEstado(uuid, 'error', mensaje);
    }
  }
  return resultado;
};

export default ejecutarEliminaciones;
